<script lang="ts" setup>
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'
import Image from './Image.vue'

interface Props {
  images: CarDetailsImage[]
  withLabels?: boolean
}

defineProps<Props>()
</script>

<template>
  <div
    class="details-images -mr-2 sm:-mx-2"
    :class="{
      'px-1.5': withLabels,
      'flex flex-wrap md:gap-2 xl:grid xl:grid-cols-10': !withLabels,
    }"
  >
    <div
      v-for="image in images"
      :key="image.id"
      :class="{
        'flex items-center justify-between border-b border-[#c1c1c1] p-1 text-left':
          withLabels,
        'w-1/3 pb-2 pr-2 sm:h-[90px] sm:w-[120px] md:p-0 xl:col-span-1 xl:w-auto':
          !withLabels,
      }"
    >
      <SectionsDetailsElementsImageLabel
        v-if="withLabels"
        :image="image"
      />

      <Image
        :image="image"
        :class="{ 'w-16 min-w-[64px]': withLabels, 'w-full': !withLabels }"
        :overlay-size="withLabels ? 'small' : undefined"
      />
    </div>
  </div>
</template>
